<template>
<div id="dergeParkhang">
  <nav>
    <ol class="breadcrumb">
      <router-link class="breadcrumb-item" to="/avatamsaka/intro/1">
        {{$t('avatamsaka.dergePage.backIntro')}}
      </router-link>
    </ol>
  </nav>
  <div class="sectionIntro">
    <div class="sectionBack">
    </div>

    <div class="content">
      <div class="introContent">
        <h2>{{$t('avatamsaka.dergePage.title')}}</h2>
        <p>
          {{$t('avatamsaka.dergePage.topContent')}}
        </p>
      </div>
      <div class="introCover">
        <div class="imgContent">
          <img src="@/../static/image/content/DergeParkhang/Derge-Parkhang-3.jpg" />
        </div>
      </div>
    </div>


  </div>

  <div class="mainContent" v-html="$t('avatamsaka.dergePage.mainContent')"></div>
  <img class="imgFloatLeft" src="../../static/image/content/DergeParkhang/Derge-Parkhang-1.jpg" />
  <div class="mainContent" v-html="$t('avatamsaka.dergePage.mainContent02')"></div>

  <div class="storyTitle ">
    {{$t('avatamsaka.dergePage.categoryTitle')}}
  </div>

  <div class="sectionVersion">
    <div class="versionGroup">
      <div class="version">

        <div class="imgContent">
          <img src="@/../static/image/content/DergeParkhang/Narthang.png" />
        </div>
        <div class="content">
          <h2>
            {{$t('avatamsaka.dergePage.categoryType01Title')}}
          </h2>
          <p v-html="$t('avatamsaka.dergePage.categoryType01')">
          </p>
        </div>
      </div>
      <div class="version">
        <div class="content">
          <h2>
            {{$t('avatamsaka.dergePage.categoryType02Title')}}
          </h2>
          <p v-html="$t('avatamsaka.dergePage.categoryType02')">
          </p>
        </div>
        <div class="imgContent">
          <img src="@/../static/image/content/DergeParkhang/Meru.jpg" />
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'dergeParkhang',
  data() {
    return {};
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#dergeParkhang {
    nav ol {
        margin: 0;
    }

    .imgFloatLeft {
        float: left;
        max-width: 45vw;
        padding: 0px 2em 2em 60px;
    }

    .mainContent {
        margin: 40px;
        padding: 20px;
        margin-top: 0;
        padding-top: 0;
        text-align: left;
    }

    .categoryArea {
        clear: both;
        text-align: left;
        margin: 1.8em;
        display: flex;

        .categoryContent {
            margin: 5px 1.5em;
            padding: 2em;
            flex: 1;
        }
        .categoryContent:nth-child(2) {
            border-left: 2px solid #4f5442;
        }
    }

    .storyTitle {
        clear: both;
        text-align: center;
        padding-top: 20px;
        width: 100%;
        font-size: 2em;
        font-weight: 500;
    }

    .sectionIntro {
        padding-bottom: 0;
        position: relative;

        .sectionBack {
            margin-bottom: 40px;
            width: 20%;
            height: 100%;
            right: 0;
            background: #d9e2c4;
            position: absolute;
            z-index: -1;
        }

        .sectionBack::after {
            border-top: 20vw solid #d9e2c4;
            border-left: 20vw solid transparent;
            z-index: -1;
            content: "";
            top: 100%;
            left: 0;
            position: absolute;
        }

        .content {
            display: flex;

            .introContent {

                flex: 2;
                margin: 60px 40px 40px;
                padding-right: 0;
                margin-right: 0;
                margin-bottom: 0;
                padding: 20px 20px 0;
                text-align: left;
                p {
                    padding: 20px 0;
                }
            }

            .introCover {
                align-self: center;
                flex: 2;
                padding: 1em;
                .imgContent {
                    img {
                        width: 80%;
                        float: left;
                    }
                }
            }
        }
    }

    .sectionVersion {
        margin-top: 2em;

        .versionGroup {
            display: flex;
            flex-direction: column;
            .version {
                display: flex;
                flex-direction: row;
                background: #d9e2c4;
                margin: 0 2em 1em;
                padding: 20px;
                height: auto;
                flex: 1;
                position: relative;

                .content {
                    text-align: left;
                    flex: 3;
                    padding: 15px;
                    font-size: 1.1em;
                    font-weight: 400;
                    align-self: center;
                    h2 {
                        padding-bottom: 0.6em;
                        font-weight: bold;
                        margin-bottom: 0;
                    }
                    h2:hover {
                        cursor: pointer;
                    }
                    p {
                        padding-top: 0;
                        margin-top: 0;
                    }
                }
                .imgContent {
                    flex: 1;
                    padding-right: 30px;
                    align-self: center;
                    img {
                        width: 100%;
                    }
                }
            }
        }

    }

    @media (max-width: 1024px) {

        h2 {
            text-align: center;
        }

        button {
            display: block;
            margin: 20px auto;
        }

        .imgFloatLeft {
          float: none;
          min-width: calc(100% - 120px);
          margin: 1em 60px;
          padding: 0px;
        }

        .mainContent {
          margin-bottom: 0px;
          padding-bottom: 0px;
        }

        .sectionIntro {

          .content {
            flex-direction: column;
            .introContent {

                p {
                    font-size: 1em;
                    margin: 0;
                    padding: 0 20px;
                    padding-bottom: 20px;
                    position: relative;
                    line-height: 1.2em;
                    text-align: left;
                    line-height: 2em;
                    margin: 0px;
                }

                flex: 2;
                padding: 0;
                z-index: 1;
                background: rgba(255, 255, 255, 0.55);
                margin: 20px;
                text-align: left;
                align-self: center;
            }

            .introCover {
                position: relative;
                right: 0;
                padding: 0;
                margin: 0px 40px 20px 40px;
                text-align: center;
                img {
                  min-width: 100%;
                }
            }
          }

        }

        .storyTitle {
          font-size: 1.5em;
        }

        .sectionVersion {

            margin-top: 0;

            .versionGroup {
                height: auto;
                width: 100%;
                display: grid;
                width: 100%;
                .version {
                    background: #d9e2c4;
                    margin: 0 30px 30px;
                    padding: 20px;
                    height: auto;
                    position: relative;
                    display: block;

                    .content {
                        height: auto;
                        position: relative;
                        overflow: visible;
                        float: none;
                        clear: both;
                        h2 {
                            padding-bottom: 0;
                            font-weight: bold;
                            font-size: 0.9em;
                            margin-bottom: 0;
                            padding: 1em 0px;
                        }
                        h2:hover {
                            cursor: pointer;
                        }
                        p {
                          position: relative;
                          font-size: 0.8em;
                          margin: 0;
                          padding: 0;
                          height: auto;
                          line-height: 1.2em;
                          text-align: center;
                          margin-right: -0.9em;
                          padding-right: 0.9em;
                          text-align: justify;
                        }
                    }
                    .imgContent {
                        padding-right: 0;
                        float: left;
                        width: 100%;
                        display: block;
                        img {
                          width: 100%;
                          height: auto;
                        }
                    }
                }

                .version:nth-child(2) {
                  display: flex;
                  flex-direction: column-reverse;
               }
            }

            :first-child {
                .version:first-child {
                    margin-top: 30px;
                }
            }

        }

    }

    @media (max-width: 768px) {
      .mainContent {
        margin: 0px;
      }
        .categoryArea {

            flex-direction: column;
            margin-top: 0;

            .categoryContent {
                margin: 0;
                padding: 0;
            }

            .categoryContent:nth-child(2) {
                border: none;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/DergeParkhang.vue